import { render, staticRenderFns } from "./manage-self-assessment-breakdown.vue?vue&type=template&id=64cad12b&"
import script from "./manage-self-assessment-breakdown.vue?vue&type=script&lang=js&"
export * from "./manage-self-assessment-breakdown.vue?vue&type=script&lang=js&"
import style0 from "./manage-self-assessment-breakdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports